import styled from 'styled-components'
import { Theme, Button } from '@pga/pga-component-library'

const mobile = 776

export const StyledContainer = styled.div`
  display: flex;
  align-items: center;
  padding: 46px 72px;
  max-width: 1122px;
  border: 3px dashed ${Theme.colors.greyBlue};
  border-radius: 6px;
  @media screen and (max-width: ${mobile}px) {
    flex-direction: column;
    align-items: center;
  }
`

export const StyledTitle = styled.div`
  font-size: 22px;
  font-family: ${props => props.theme.fonts.body};
  font-weight: bold;
  margin-bottom: 5px;
  color: ${props => props.theme.colors.secondary};
  @media screen and (max-width: ${mobile}px) {
   text-align: center;
  }
`

export const StyledContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-right: 53px;
  @media screen and (max-width: ${mobile}px) {
    margin-right: 0px;
  }
`

export const StyledInfo = styled.div`
  color: #486280;
  font-size: 16px;
  font-weight: 500;
  line-height: 25px;
  @media screen and (max-width: ${mobile}px) {
   text-align: center;
  }
`

export const StyledButton = styled(Button)`
  padding: 18px 52px;
  border-radius: 3px;
  border-width: 1px;
  font-weight: 600;
  font-size: 14px;
  @media screen and (max-width: ${mobile}px) {
    margin-top: 35px;
    width: 100%;
  }
`

export const StyledLink = styled.a`
  :hover {
    text-decoration: none;
  }
`
